import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { Button } from "components/bootstrap";
import { OverlayTrigger, Timestamp, IconButton } from "components/common";
import { Badge, Row } from "common/components";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import { useModalContext } from "common/contexts";
import { RiskScoreBadge } from "security-app/components/common";
import DescriptionCell from "security-app/components/SecurityEvents/EventProcedures/DescriptionCell";
import { MODAL_TYPES } from "./Modals";
import ProcedureTitlesOverlay from "./ProcedureTitlesOverlay";
const TITLE_VARIABLE_REGEX = /\$\{([^}]+)\}/;
export const ExpandButton = styled(IconButton)`
  background-color: ${({ theme }) => theme.colors.button.gray.background};
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.button.gray.background};
  }
`;
export const RowTitleButton = styled.div`
  cursor: pointer;
  max-width: 100%;
  height: auto;
  text-align: left;

  & > code:hover {
    text-decoration: underline;
  }
`;
const TitleCell = ({
  procedure,
  firstProcedureId
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const { id: invId } = useParams();
  const { toggleSection } = useExpandedSections();
  const toggleExtraSection = () => {
    setIsOpened((prev) => !prev);
    toggleSection(procedure.id, "restFieldsExpandedSection");
  };
  useEffect(() => {
    if (firstProcedureId && procedure.id === firstProcedureId) toggleSection(procedure.id, "restFieldsExpandedSection");
    setIsOpened(firstProcedureId === procedure.id);
  }, [firstProcedureId, procedure.id, toggleSection]);
  const hasVariablesInTitle = procedure.title && TITLE_VARIABLE_REGEX.test(procedure.title);
  const formattedTitle = (title) => {
    const parts = title.split(TITLE_VARIABLE_REGEX);
    return parts.map((part, index) => index % 2 === 0 ? part : /* @__PURE__ */ React.createElement("code", { key: `${part}-${index}` }, part));
  };
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "md" }, /* @__PURE__ */ React.createElement(
    ExpandButton,
    {
      name: isOpened ? "keyboard_arrow_up" : "keyboard_arrow_down",
      title: "Expand details",
      onClick: toggleExtraSection
    }
  ), /* @__PURE__ */ React.createElement(React.Fragment, null, hasVariablesInTitle ? /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: "hover",
      rootClose: true,
      placement: "right",
      overlay: /* @__PURE__ */ React.createElement(ProcedureTitlesOverlay, { invId, procedureId: procedure == null ? void 0 : procedure.id }),
      title: "Possible title variables",
      width: 600
    },
    /* @__PURE__ */ React.createElement(Row, { $align: "baseline" }, /* @__PURE__ */ React.createElement(RowTitleButton, null, formattedTitle((procedure == null ? void 0 : procedure.title) || "No title set")))
  ) : /* @__PURE__ */ React.createElement(Row, { $align: "baseline" }, /* @__PURE__ */ React.createElement(RowTitleButton, null, (procedure == null ? void 0 : procedure.title) || "No title set"))));
};
const EventCountCell = ({ procedure }) => {
  const { entity, setModal, setEntity } = useModalContext();
  const onClick = () => {
    setEntity({ ...entity, eventsCount: procedure.event_count, eventIds: procedure.event_ids });
    setModal(MODAL_TYPES.INVESTIGATION_EVENT_LIST);
  };
  return /* @__PURE__ */ React.createElement(Badge, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick }, procedure.event_count));
};
export const columnRenderers = {
  attributes: {
    title: {
      renderCell: (_, procedure, { first_procedure_id }) => /* @__PURE__ */ React.createElement(TitleCell, { procedure, firstProcedureId: first_procedure_id })
    },
    description: {
      renderCell: (_, procedure) => /* @__PURE__ */ React.createElement(DescriptionCell, { mdValue: procedure.description, noExpand: true })
    },
    event_count: {
      staticWidth: 250,
      renderCell: (_, procedure) => /* @__PURE__ */ React.createElement(EventCountCell, { procedure })
    },
    risk: {
      staticWidth: 250,
      renderCell: (_, procedure) => /* @__PURE__ */ React.createElement(RiskScoreBadge, { riskScore: procedure.risk })
    },
    latest_event_at: {
      staticWidth: 250,
      renderCell: (latest_event_at) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: latest_event_at })
    },
    earliest_event_at: {
      staticWidth: 250,
      renderCell: (earliest_event_at) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: earliest_event_at })
    }
  }
};
